// assets/orchestrator.js
(function () {
  const ORCHESTRATOR_ENDPOINT = 'https://lm-orchestrator-gw-h9ihswc.ew.gateway.dev/?debug=1';

  async function askOrchestrator(text, customerId = null) {
    const payload = customerId ? { text, customer_id: customerId } : { text };

    // WICHTIG: text/plain => kein Preflight
    const res = await fetch(ORCHESTRATOR_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const eText = await res.text().catch(() => '');
      throw new Error(`Orchestrator ${res.status}: ${eText || res.statusText}`);
    }
    return res.json();
  }

  // global machen:
  window.askOrchestrator = askOrchestrator;
})();